export const listingBookingSettings = {
  section01: {
    title: "Réservations directes pour cette annonce",
  },
  motor: {
    activeTitle: "Moteur de réservation actif",
    inactiveTitle: "Moteur de réservation inactif",
    activeDesc: "Les clients peuvent réserver cette annonce directement depuis son lien.",
    inactiveDesc: "Les réservations directes sont désactivées pour cette annonce.",
    statusOn: "Actif",
    statusOff: "Inactif",
  },
  payment: {
    title: "Quand le client paie-t-il ?",
    onArrival: {
      name: "Paiement à l'arrivée",
      hint: "Réservez gratuitement, payez à votre arrivée.",
    },
    online: {
      name: "Paiement en ligne",
      hint: "Payez au moment de la confirmation de la réservation.",
    },
  },
  common: {
    saving: "Enregistrement…",
    onlyOnlineBadge: "Paiement en ligne uniquement",
  },
  hold: {
    title: "Délai de blocage",
    desc: "Le calendrier est bloqué pendant que le client effectue le paiement.<br>S'il ne paie pas dans le délai fixé, <strong>la disponibilité est libérée automatiquement</strong>.",
  },
  units: {
    min: "min",
    hour: "heure",
    hours: "heures",
  },
  partial: {
    title: "Paiement partiel",
    cardTitle: "Autoriser à ne payer qu'une partie à la réservation",
    descOn: "<strong>Activé.</strong> Le client peut payer <strong>{percent}%</strong> maintenant et le reste avant l'arrivée (ou payer la totalité).",
    descOff: "<strong>Désactivé.</strong> Le client paie le <strong>montant total</strong> à la réservation.",
    blockTitle: "Le reste est payé à l'hébergement",
    blockOn: "<strong>Activé.</strong> Le client paie <strong>seulement {percent}%</strong> en ligne ; le reste est payé <strong>à l'arrivée</strong> (il ne peut pas payer la totalité en ligne).",
    blockOff: "<strong>Désactivé.</strong> Le client peut choisir de payer {percent}% ou la totalité en ligne.",
  },
  reminder: {
    title: "Rappel de solde",
    cardTitle: "Envoyer un rappel pour payer le solde restant",
    daysBefore: "{count} jour avant | {count} jours avant",
    descOn: "<strong>Activé.</strong> <strong>{daysBefore}</strong> l'arrivée (vers 09:00, heure de l'établissement), le client reçoit un lien pour payer le solde restant par <strong>WhatsApp et e-mail</strong>.",
    descOff: "<strong>Désactivé.</strong> Le client ne reçoit aucun rappel pour payer le solde en ligne avant l'arrivée.",
    daysLabel: "Jours avant l'arrivée",
    hint: "Envoyé une seule fois, et uniquement aux clients ayant un solde restant. Si le reste est payé à l'hébergement, il n'est pas envoyé.",
  },
  approve: {
    title: "Approuver les réservations",
    cardTitle: "Approuver chaque réservation avant de la confirmer",
    descOn: "<strong>Activé.</strong> Chaque réservation reste <strong>en attente de votre approbation</strong> : vous recevez une notification et décidez de l'accepter ou de la refuser. Elle n'est confirmée qu'une fois que vous l'approuvez.",
    descOff: "<strong>Désactivé.</strong> Les réservations sont <strong>confirmées automatiquement</strong> une fois le paiement effectué. Activez cette option si vous préférez examiner et approuver chaque demande vous-même.",
  },
  toasts: {
    statusUpdatedAll: "Statut mis à jour sur toutes les unités.",
    statusUpdated: "Statut mis à jour.",
    statusError: "Mise à jour impossible.",
    paymentUpdated: "Mode de paiement mis à jour.",
    paymentError: "Impossible d'enregistrer le mode de paiement.",
    partialUpdated: "Paiement partiel mis à jour.",
    partialError: "Impossible d'enregistrer le paiement partiel.",
    reminderUpdated: "Rappel mis à jour.",
    reminderError: "Impossible d'enregistrer le rappel.",
    saved: "Enregistré.",
    saveError: "Enregistrement impossible.",
    linkCopied: "Lien copié.",
    copyError: "Copie impossible.",
  },
  share: {
    whatsappText: "Bonjour 👋 Voici le lien pour réserver : {link}",
  },
};
